import type { ComputedRef } from 'vue';
import { computed, ref } from 'vue';
import { DEFAULT_NOTIONAL } from '@/utils/portfolioDefaults';

const internalNotional = ref(DEFAULT_NOTIONAL);

const reportingNotional = computed(() => {
  return internalNotional.value;
});

const updateParameters = (val: string): void => {
  const validVal = parseFloat(val);
  if (!isNaN(validVal) && validVal >= 0) internalNotional.value = validVal;
};

const toDefault = (): void => {
  internalNotional.value = DEFAULT_NOTIONAL;
};

export default function (): {
  reportingNotional: ComputedRef<number>;
  updateParameters: (units: string) => void;
  toDefault: () => void;
} {
  return {
    reportingNotional,
    updateParameters,
    toDefault,
  };
}
